// Shared formation-shape templates for the Classic Lineup Builder — used
// by both the public builder page and the Admin Classic Lineup Presets
// editor, so role/x/y coordinates always stay in sync between the two.
export const FORMATIONS = {
  "4-4-2": [
    { role: "GK", name: "", number: 1, x: 50, y: 88, is_gk: true },
    { role: "RB", name: "", number: 2, x: 82, y: 70 },
    { role: "RCB", name: "", number: 5, x: 60, y: 70 },
    { role: "LCB", name: "", number: 6, x: 40, y: 70 },
    { role: "LB", name: "", number: 3, x: 18, y: 70 },
    { role: "RM", name: "", number: 7, x: 82, y: 40 },
    { role: "RCM", name: "", number: 8, x: 60, y: 40 },
    { role: "LCM", name: "", number: 4, x: 40, y: 40 },
    { role: "LM", name: "", number: 11, x: 18, y: 40 },
    { role: "RST", name: "", number: 9, x: 60, y: 15 },
    { role: "LST", name: "", number: 10, x: 40, y: 15 },
  ],
  "4-3-3": [
    { role: "GK", name: "", number: 1, x: 50, y: 88, is_gk: true },
    { role: "RB", name: "", number: 2, x: 82, y: 70 },
    { role: "RCB", name: "", number: 5, x: 60, y: 70 },
    { role: "LCB", name: "", number: 6, x: 40, y: 70 },
    { role: "LB", name: "", number: 3, x: 18, y: 70 },
    { role: "RCM", name: "", number: 8, x: 72, y: 45 },
    { role: "CM", name: "", number: 4, x: 50, y: 45 },
    { role: "LCM", name: "", number: 10, x: 28, y: 45 },
    { role: "RW", name: "", number: 7, x: 80, y: 18 },
    { role: "ST", name: "", number: 9, x: 50, y: 12 },
    { role: "LW", name: "", number: 11, x: 20, y: 18 },
  ],
  "4-2-3-1": [
    { role: "GK", name: "", number: 1, x: 50, y: 88, is_gk: true },
    { role: "RB", name: "", number: 2, x: 82, y: 70 },
    { role: "RCB", name: "", number: 5, x: 60, y: 70 },
    { role: "LCB", name: "", number: 6, x: 40, y: 70 },
    { role: "LB", name: "", number: 3, x: 18, y: 70 },
    { role: "RDM", name: "", number: 4, x: 60, y: 52 },
    { role: "LDM", name: "", number: 8, x: 40, y: 52 },
    { role: "RAM", name: "", number: 7, x: 78, y: 30 },
    { role: "AM", name: "", number: 10, x: 50, y: 30 },
    { role: "LAM", name: "", number: 11, x: 22, y: 30 },
    { role: "ST", name: "", number: 9, x: 50, y: 12 },
  ],
  "3-5-2": [
    { role: "GK", name: "", number: 1, x: 50, y: 88, is_gk: true },
    { role: "RCB", name: "", number: 5, x: 70, y: 72 },
    { role: "CB", name: "", number: 6, x: 50, y: 72 },
    { role: "LCB", name: "", number: 2, x: 30, y: 72 },
    { role: "RWB", name: "", number: 7, x: 85, y: 45 },
    { role: "RCM", name: "", number: 8, x: 63, y: 45 },
    { role: "CM", name: "", number: 4, x: 50, y: 45 },
    { role: "LCM", name: "", number: 10, x: 37, y: 45 },
    { role: "LWB", name: "", number: 3, x: 15, y: 45 },
    { role: "RST", name: "", number: 9, x: 60, y: 15 },
    { role: "LST", name: "", number: 11, x: 40, y: 15 },
  ],
  "5-3-2": [
    { role: "GK", name: "", number: 1, x: 50, y: 88, is_gk: true },
    { role: "RWB", name: "", number: 2, x: 85, y: 72 },
    { role: "RCB", name: "", number: 5, x: 68, y: 72 },
    { role: "CB", name: "", number: 6, x: 50, y: 72 },
    { role: "LCB", name: "", number: 4, x: 32, y: 72 },
    { role: "LWB", name: "", number: 3, x: 15, y: 72 },
    { role: "RCM", name: "", number: 8, x: 70, y: 45 },
    { role: "CM", name: "", number: 14, x: 50, y: 45 },
    { role: "LCM", name: "", number: 10, x: 30, y: 45 },
    { role: "RST", name: "", number: 9, x: 60, y: 15 },
    { role: "LST", name: "", number: 11, x: 40, y: 15 },
  ],
  "3-4-2-1": [
    { role: "GK", name: "", number: 1, x: 50, y: 88, is_gk: true },
    { role: "RCB", name: "", number: 5, x: 65, y: 72 },
    { role: "CB", name: "", number: 6, x: 50, y: 74 },
    { role: "LCB", name: "", number: 4, x: 35, y: 72 },
    { role: "RWB", name: "", number: 2, x: 84, y: 48 },
    { role: "RCM", name: "", number: 8, x: 60, y: 48 },
    { role: "LCM", name: "", number: 10, x: 40, y: 48 },
    { role: "LWB", name: "", number: 3, x: 16, y: 48 },
    { role: "RAM", name: "", number: 7, x: 65, y: 22 },
    { role: "LAM", name: "", number: 11, x: 35, y: 22 },
    { role: "ST", name: "", number: 9, x: 50, y: 10 },
  ],
};
